import { measurementConstants } from "../../constants";

export function measurements(state = {}, action) {
  switch (action.type) {
    // get all
    case measurementConstants.GET_ALL_REQUEST:
      return {
        loading: true,
      };
    case measurementConstants.GET_ALL_SUCCESS:
      return {
        items: action.items,
      };
    case measurementConstants.GET_ALL_FAILURE:
      return {
        error: action.error,
      };

    // add
    case measurementConstants.ADD_REQUEST:
      return {
        loading: true,
      };
    case measurementConstants.ADD_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case measurementConstants.ADD_FAILURE:
      return {
        error: action.error,
      };

    // update
    case measurementConstants.UPDATE_REQUEST:
      return {
        loading: true,
      };
    case measurementConstants.UPDATE_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case measurementConstants.UPDATE_FAILURE:
      return {
        error: action.error,
      };

    // delete
    case measurementConstants.DELETE_REQUEST:
      return {
        loading: true,
      };
    case measurementConstants.DELETE_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case measurementConstants.DELETE_FAILURE:
      return {
        error: action.error,
      };

    // clear
    case measurementConstants.CLEAR:
      return {};

    default:
      return state;
  }
}
